import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-link-icon',
  imports: [],
  templateUrl: './link-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './link-icon.component.scss',
})
export class LinkIconComponent {}
